import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef } from 'react'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

interface CheckboxProps extends ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  size?: 'sm' | 'default'
}

export const Checkbox = forwardRef<ComponentRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ checked = false, className, size = 'default', ...props }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      checked={checked}
      className={cn(
        'peer shrink-0 border-[0.5px] border-gray-300 bg-gray-50 focus-visible:ring-1 focus-visible:ring-gray-500 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:stroke-white',
        size === 'sm'
          ? 'size-4 rounded-sm data-[state=checked]:border data-[state=checked]:border-blue-700 data-[state=checked]:bg-blue-500'
          : 'rounded-allocated size-6 data-[state=checked]:border data-[state=checked]:border-blue-800 data-[state=checked]:bg-blue-500',
        className
      )}
      {...props}>
      <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center')}>
        <Icons.check className={size === 'sm' ? 'size-2' : 'size-4'} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
)
